import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ModernSelect as Select } from 'shared/ui/ModernSelect';
import { BoxesListFilterKeys } from '../../model/types';
import { BoxDeactivationReason } from 'entities/Box';

interface DeactivationReasonSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const DeactivationReasonSelect: FC<DeactivationReasonSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('boxes');

  const deactivationReasonOptions = Object.values(BoxDeactivationReason).map((option) => ({
    label: t(option),
    value: option,
  }));

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(BoxesListFilterKeys.deactivationReason);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Deactivation reason')}
      placeholder={t('All')}
      bordered
      allowClear
      options={deactivationReasonOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
